import { ButtonProps } from 'antd';
import { FC } from 'react';
import BaseButton from './BaseButton';

const PrimaryButton: FC<ButtonProps> = (props) => (
  <BaseButton size={props.size ? props.size : 'large'} type="primary" {...props} />
);

export default PrimaryButton;
